var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authenticated-student warning"},[_c('h2',[_vm._v("Warning - Educators Only!")]),_vm._v(" "),_c('p',[_vm._v("\n\t\tReadWorks has noticed suspicious activity. Students are not allowed to create educator accounts. Students that proceed may be reported directly to\n\t\ttheir teachers or schools.\n\t")])])
}]

export { render, staticRenderFns }